import { useEffect, useRef } from "react";

export const Waveform = ({ peaks = [], color, progress = 0, dim = false, height = 84, onSeek, testId }) => {
  const canvasRef = useRef(null);
  const wrapRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current, wrap = wrapRef.current;
    if (!canvas || !wrap) return;
    const draw = () => {
      const w = wrap.clientWidth, h = height, dpr = window.devicePixelRatio || 1;
      canvas.width = w * dpr; canvas.height = h * dpr;
      canvas.style.width = `${w}px`; canvas.style.height = `${h}px`;
      const ctx = canvas.getContext("2d");
      ctx.scale(dpr, dpr);
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = "#0B0E14";
      ctx.fillRect(0, 0, w, h);
      ctx.strokeStyle = "rgba(255,255,255,0.05)";
      for (let x = 0; x < w; x += w / 20) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, h); ctx.stroke(); }
      const n = peaks.length;
      if (!n) return;
      const mid = h / 2, playX = progress * w;
      const barW = w / n;
      for (let i = 0; i < n; i++) {
        const x = i * barW, amp = Math.max(1, peaks[i] * (h / 2 - 3));
        ctx.fillStyle = x < playX ? color : `${color}66`;
        ctx.globalAlpha = dim ? 0.25 : 1;
        ctx.fillRect(x, mid - amp, Math.max(1, barW - 0.5), amp * 2);
      }
      ctx.globalAlpha = 1;
      ctx.strokeStyle = "rgba(255,255,255,0.12)";
      ctx.beginPath(); ctx.moveTo(0, mid); ctx.lineTo(w, mid); ctx.stroke();
      ctx.fillStyle = "#F1F5F9";
      ctx.fillRect(playX - 0.5, 0, 1.5, h);
    };
    draw();
    const ro = new ResizeObserver(draw);
    ro.observe(wrap);
    return () => ro.disconnect();
  }, [peaks, color, progress, dim, height]);

  const handleClick = (e) => {
    const rect = wrapRef.current.getBoundingClientRect();
    onSeek?.((e.clientX - rect.left) / rect.width);
  };

  return (
    <div ref={wrapRef} data-testid={testId} onClick={handleClick} className="w-full cursor-crosshair select-none rounded-sm overflow-hidden border border-[#1c2433]">
      <canvas ref={canvasRef} />
    </div>
  );
};
